<lib-dropdown
  [options]="dropdownOptions()"
  [value]="selectedStatus()"
  (valueChange)="onStatusSelect($event)"
  (dropdownOpened)="onDropdownOpenChange($event)"
>
  <ng-template libDropdownItemPrefix let-item let-prefixData="prefixData">
    <div [ngClass]="[prefixClassBase, prefixData.bgClass]">
      {{ prefixData.label }}
    </div>
  </ng-template>

  @if (triggerType() === 'normal') {
    <div
      libDropdownTrigger
      class="flex h-10 w-[220px] items-center gap-2 rounded-2xl border border-text-extra-light bg-background-white px-4 py-2 hover:cursor-pointer"
    >
      <div [ngClass]="[prefixClassBase, selectedStatusOption()?.bgClass]">{{ selectedStatus()[0] }}</div>
      <div class="typo-h4-medium">{{ selectedStatusOption()?.labelKey ?? '' | translate }}</div>

      <svg-icon [key]="dropdownIcon()" size="md" class="ml-auto text-text-tertiary" />
    </div>
  }

  @if (triggerType() === 'small') {
    <div libDropdownTrigger class="flex h-[22px] w-fit items-center gap-1 rounded-[8px] bg-background-tag p-[2px] hover:cursor-pointer">
      <div [ngClass]="[prefixClassBase, selectedStatusOption()?.bgClass]">{{ selectedStatus()[0] }}</div>

      <svg-icon [key]="dropdownIcon()" size="sm" class="text-primary-blue" />
    </div>
  }
</lib-dropdown>
